export enum Cy_Katalog {
  title = 'seznam-sablon-title',

  specifikaceTab = 'seznam-sablon-specifikace-tab',

  identifikator = 'seznam-sablon-identifikator',
  nazev = 'seznam-sablon-nazev',
  verze = 'seznam-sablon-verze',
  typ = 'seznam-sablon-typ',
  gestor = 'seznam-sablon-gestor',
  platnostOd = 'seznam-sablon-platnost-od',
  platnostDo = 'seznam-sablon-platnost-do',
  schvaleno = 'seznam-sablon-schvaleno',
  publikovano = 'seznam-sablon-publikovano',

  search = 'seznam-sablon-search-button',
  clear = 'seznam-sablon-clear-filter-button',

  form = 'seznam-sablon-form',
  table = 'seznam-sablon-table',

  dokumentaceButton = 'seznam-sablon-dokumentace-button',
}

// readonly Cy_Katalog = Cy_Katalog;
// [attr.data-cy]="Cy_Katalog.title"
